import React, {useContext, useEffect, useState} from 'react';
import {Card, Table, Tag, Typography, Space} from 'antd';
import {GiftOutlined, TeamOutlined} from '@ant-design/icons';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {internalApi} from "../../../../common/axios";
import {buildUrl} from "../../../../shared/utils/net";
import toast from "react-hot-toast";
import dayjs from "dayjs";

const {Title, Text} = Typography;

const Invite = () => {
    const {playerData} = useContext(PlayerContext);
    const [rows, setRows] = useState([]);
    const [tbl, setTbl] = useState({});
    const [loading, setLoading] = useState(false);

    const lastRewardedRound = playerData.playerInfo?.socialContentData?.inviteData?.lastRewardedRound || 0;
    console.log(playerData);
    useEffect(() => {
        if (playerData.pid) {
            fetchData();
        }
    }, [playerData.pid]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await internalApi.get(buildUrl('/player/invite', {pid: playerData.pid}));
            setRows(res.data.rows || []);
            setTbl(res.data.tbl || []);
        } catch (e) {
            toast.error('친구 초대 데이터를 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    const missionData = Object.values(tbl)
        .filter(item => item.inviteRound >= 1)
        .map(item => ({
            ...item,
            achievement: `${Math.min(rows.length, item.inviteCount)} / ${item.inviteCount}`,
            rewarded: item.inviteRound <= lastRewardedRound,
        }));

    const missionColumns = [
        {
            title: '회차',
            dataIndex: 'inviteRound',
            key: 'inviteRound',
        },
        {
            title: '달성도',
            dataIndex: 'achievement',
            key: 'achievement',
        },
        {
            title: '상태',
            key: 'status',
            render: (_, record) => (
                record.rewarded
                    ? <Tag color="success">보상받음</Tag>
                    : <Tag color="processing">진행 중</Tag>
            ),
        },
    ];

    const inviteColumns = [
        {
            title: 'PID',
            dataIndex: 'invitee',
            key: 'invitee',
        },
        {
            title: '초대 날짜',
            dataIndex: 'created',
            key: 'created',
            render: (val) => val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
    ];

    return (
        <div style={{padding: '20px'}}>
            <Space direction="vertical" style={{width: '100%'}} size="large">
                <Card
                    title={
                        <Space align="center" size="middle">
                            <GiftOutlined style={{fontSize: 20}}/>
                            <div>
                                <Title level={4} style={{margin: 0}}>친구 초대 보상</Title>
                                <Text type="secondary" style={{fontSize: '12px'}}>
                                    보상 수령 회차: {lastRewardedRound}
                                </Text>
                            </div>
                        </Space>
                    }
                >
                    <Table
                        columns={missionColumns}
                        dataSource={missionData}
                        rowKey="inviteRound"
                        pagination={false}
                        loading={loading}
                        locale={{emptyText: '미션 데이터가 없습니다.'}}
                        size="small"
                    />
                </Card>

                <Card
                    title={
                        <Space align="center" size="middle">
                            <TeamOutlined style={{fontSize: 20}}/>
                            <div>
                                <Title level={4} style={{margin: 0}}>초대 목록</Title>
                                <Text type="secondary" style={{fontSize: '12px'}}>
                                    총 {rows.length}명 초대
                                </Text>
                            </div>
                        </Space>
                    }
                >
                    <Table
                        columns={inviteColumns}
                        dataSource={rows}
                        rowKey="invitee"
                        pagination={{pageSize: 10}}
                        loading={loading}
                        locale={{emptyText: '초대 내역이 없습니다.'}}
                        size="small"
                    />
                </Card>
            </Space>
        </div>
    );
};

export default Invite;